import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComments = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 54.60029 54.59528",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "comments" }), /* @__PURE__ */ _jsx("path", {
		d: "M53.35029,23.90079c0,11.88233-11.66648,21.51211-26.05484,21.51211a30.27993,30.27993,0,0,1-4.92752-.39418L8.929,52.0549a1.28376,1.28376,0,0,1-1.76651-1.6633l4.24291-9.44632C5.22955,37.01265,1.25,30.83687,1.25,23.90079,1.25,12.0184,12.90708,2.38862,27.29545,2.38862S53.35029,12.0184,53.35029,23.90079Z",
		style: {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	})]
});
export default SvgComments;
